import { useMemo } from 'react';

import { useGetMyOffersQuery } from '../api';
import { offerItemListTransformer } from '../helpers';

export function useMyOffersList() {
  const { data: offers, isLoading } = useGetMyOffersQuery();
  const transformed = useMemo(() => offers?.map(offerItemListTransformer), [offers]);
  return { data: transformed, isLoading };
}
